/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

export { _typeof as _ };
//# sourceMappingURL=dep-6da93342.mjs.map
